import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FollowStatus } from "sprout-graphql";
import { Button } from "sprout-ui-dom/dist/Button";
import { NotificationsOffOutlined, NotificationsActiveOutlined } from "sprout-ui-icons";
import useSetTopicFollow from "../graphql/mutations/useSetTopicFollow";
const TopicPageViewsTopicNotificationButton = (props)=>{
    const { topic: { rootTopicOrSelf  } ,  } = props;
    const { memberLevel , currentUserFollowStatus , nodeId , id  } = rootTopicOrSelf || {};
    const setTopicFollow = useSetTopicFollow({
        topicId: Number(id),
        nodeId: String(nodeId),
        withNotifications: currentUserFollowStatus !== FollowStatus.Subscribed
    });
    /**
   * Only show button to non-members who are following the tree.
   * It determines whether they want to receive new leaf notifications or not.
   */ if (!memberLevel && currentUserFollowStatus && [
        FollowStatus.Following,
        FollowStatus.Subscribed
    ].includes(currentUserFollowStatus)) return /*#__PURE__*/ _jsxs(Button, {
        variant: "circle",
        onClick: setTopicFollow,
        children: [
            currentUserFollowStatus === FollowStatus.Following && /*#__PURE__*/ _jsx(NotificationsOffOutlined, {}),
            currentUserFollowStatus === FollowStatus.Subscribed && /*#__PURE__*/ _jsx(NotificationsActiveOutlined, {})
        ]
    });
    return null;
};
export default TopicPageViewsTopicNotificationButton;
